// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3EoT6","box":"WorkspacesBox_box__3u7YT","node":"WorkspacesBox_node__1jkK2"};